export default __webpack_public_path__ + "static/thehub-cf6566b9fb6e1a8c83a3e027684be0e5.jpeg";